import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-operation-factories',
  templateUrl: './operation-factories.component.html',
  styleUrls: ['./operation-factories.component.css']
})
export class OperationFactoriesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListOperationFactories: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2037, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadOperationFactories(): Promise<void> {
        if (!!this.setting?.argtype && !!this.setting?.argvalue) {
            return this.itemsListOperationFactories = await this.datatask.Post(2036, {
                argtype: this.setting?.argtype,
                argvalue: this.setting?.argvalue
            });
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadOperationFactories();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    webpage_heading: string;
    argtype: string;
    argvalue: string;
}
